import { MainService } from "@/services/MainService"
import store from "@/store/store"
import { ModuleNamespaces } from "@/store/types/storeGlobalTypes"
import { ref } from "vue"
import { onMounted } from "vue"
import { FileData } from "./useFiles"
import { getFileExtension } from "@/helpers/file"
import { OpenMSOffice } from "@/components/FileManager/types/FileManagerTypes"

interface ResponseUseMSOffice {
  openMSOfficeLocal: (file: any | null) => void
  isMSOfficeLocal: (file: FileData) => boolean
}

export const MSOFFICE_URL = process.env.VUE_APP_API_URL

export default function useMSOffice(): ResponseUseMSOffice {
  const openMSOfficeConfig = ref<OpenMSOffice>(OpenMSOffice.WOPI)

  const openMSOfficeLocal = async (file: FileData) => {
    const selectedFileId = file.id
    const selectedFileName = file.originalFileName
    const url = `/repository/webdav-token/${selectedFileId}`
    const { data } = await new MainService().getData(url)
    const extension = getFileExtension(file.originalFileName)
    const openWord = getMSOfficeLocalURI(extension)
    const urlFile = `${openWord}${MSOFFICE_URL}webdav/${data}/${encodeURIComponent(selectedFileName)}`
    window.open(urlFile, '_blank')
  }

  const getMSOfficeLocalURI = (extension?: string) => {
    switch (extension) {
      case '.doc':
      case '.docx':
      case 'doc':
      case 'docx':
      case '.rtf':
      case 'rtf':
        return 'ms-word:ofe|u|'
      case '.xls':
      case '.xlsx':
      case 'xls':
      case 'xlsx':
        return 'ms-excel:ofe|u|'
      case '.ppt':
      case '.pptx':
      case 'ppt':
      case 'pptx':
        return 'ms-powerpoint:ofe|u|'
      default:
        return ''
    }
  }

  const isMSOfficeLocal = (file: FileData): boolean => {
    const extension = getFileExtension(file.originalFileName)
    if (!extension) {
      return false
    }
    const ext = getMSOfficeLocalURI(extension)
    return openMSOfficeConfig.value === OpenMSOffice.LOCAL && Boolean(ext)
  }

  onMounted(async () => {
    const config = await store.dispatch(`${ModuleNamespaces.FILE_MANAGER}/fetchOpenOfficeIn`)
    openMSOfficeConfig.value = config || OpenMSOffice.WOPI
  })

  return {
    openMSOfficeLocal,
    isMSOfficeLocal
  }
}
